import { useForm, useFieldArray } from "react-hook-form";

const PodcastForm = ({podcast, onSave}) => {
  const { control, register, handleSubmit, watch } = useForm({
    defaultValues: podcast
  });
  const file = watch("contentFile");
  const { fields, append, remove } = useFieldArray({control, name: 'narrations'});

  return (
    <form onSubmit={handleSubmit(onSave)}>
      <h2 className="h5 mb-3">Podcast details</h2>
      <label htmlFor="">Narrators voice*</label>
      <div className="form-group">
        <select className="custom-select" name="voice" ref={register}>
          <option value="female">Female voice</option>
          <option value="male">Male voice</option>
        </select>
      </div>
      <div className="form-group">
        <label htmlFor="">Podcast title*</label>
        <input type="text" name="title" className="form-control" ref={register} />
        <p class="form-text text-muted">
          Always used &amp; overwrites the first episode title below when there only 1 episode
        </p>
      </div>
      <div class="form-group">
        <label htmlFor="">Notes about this podcast <small class="text-muted">(optional)</small></label>
        <textarea class="form-control" id="" rows="2" name="notes" ref={register}></textarea>
      </div>
      <h2 className="h5 mt-5 mb-3">Content</h2>
      <div className="form-group">
        <label htmlFor="">Submission type</label>
        <select className="custom-select" name="contentType" ref={register}>
          <option value="url">URL</option>
          <option value="file">File</option>
        </select>
      </div>
      <div className="form-group">
        <label htmlFor="">Content URL</label>
        <input type="text" name="contentUrl" className="form-control" ref={register} />
      </div>
      <div className="form-group">
        <label htmlFor="">Content File
          &nbsp;
          { podcast?.contentFileUrl && (
            <small class="text-muted">
              <a href={podcast.contentFileUrl}>(see file)</a>
            </small>
          )}
        </label>
        <div class="custom-file">
          <input type="file" class="custom-file-input" name="contentFile" ref={register} />
          <label class="custom-file-label">
            {(file && file.length > 0) ? (
              <>{file[0].name}</>
            ) : (
              <>Choose file <small className="text-muted">(Max 10mb)</small></>
            )}
          </label>
        </div>
      </div>
      <h2 className="h5 mt-5 mb-3">Edited content</h2>
      <div className="form-group">
        <label htmlFor="">Edit content</label>
        <select className="custom-select" name="contentEdit" ref={register}>
          <option value="yes">Yes</option>
          <option value="no">No</option>
        </select>
      </div>
      <div className="form-group">
        <label htmlFor="">Google Drive URL <small class="text-muted">(optional)</small></label>
        <input type="text" name="contentEditUrl" className="form-control" ref={register} />
      </div>
      <h2 className="h5 mt-5 mb-3">Podcast episodes</h2>
      {fields.map((item, index) => (
          <div key={item.id}>
            <div className="form-group">
              <label>Episode title*</label>
              <input
                type="text"
                className="form-control"
                name={`narrations[${index}].title`}
                defaultValue={item.title}
                ref={register()}
              />
            </div>
            <div className="form-group">
              <label htmlFor="">Narration <small className="text-muted">(Google Drive URL)</small></label>
              <input
                type="text"
                className="form-control"
                name={`narrations[${index}].fileUrl`}
                defaultValue={item.fileUrl}
                ref={register()}
              />
            </div>
            <div className="form-group">
              <legend className="col-form-label">Status*</legend>
              <select
                className="custom-select"
                name={`narrations[${index}].status`}
                defaultValue={item.status}
                ref={register()}
              >
                <option value="in_progress">In progress</option>
                <option value="done">Done</option>
                <option value="published">Published</option>
              </select>
            </div>
            <button className="btn btn-sm btn-secondary" type="button" onClick={() => {
              remove(index);
            }}>
              Remove episode
            </button>
          </div>
      ))}
      <div className="form-group mt-4">
        <button className="btn btn-sm btn-secondary" type="button" onClick={append}>
          Add episode
        </button>
      </div>
      <div className="form-group">
        <input className="btn btn-primary float-right" type="submit" value="Update podcast" />
      </div>
    </form>
  )
}

export default PodcastForm;
